import React , { useEffect, useState } from 'react'
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import ActivePositions from './activeJobs'
import ContractResources from './contractResource'
import Positions from './position'
import UpcomingJoinee from './upcomingJoine'
import AppliedResourcesTable from './appliedCandidates'
import CandidateTimeSheet from "./candidateTimeSheet"
import TimeSheetHistory from "./timeSheetHistory"
import CheckHistoryTable from "./checkHistory";



interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}

export interface Resources {
  name: string,
  skills?: string,
  Experience?: number,
  availablity?: string,
  ExperienceRequired?: string,
  OpenFor?: string,
  AllocatedTo?: string,
  Positions?: number,
  Profiles?: string,
  PositionId?:number
}

const Table = (props: any) => {



  useEffect(() => {
    if(state)
    {
      setState(createState(state.skip, state.pageSize, props.data));
      setData(state.items)
    }
  }, [props.total, props.data])

  const createState = (skip: number, take: number, items: any) => {
    
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    }

    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    }
  }
  const [state, setState] = useState<AppState>(createState(0, 25, props.data));
  const [allocatedTo, setAllocatedTo] = useState<any>();
  const [data, setData] = useState<Array<Resources>>(state.items);
  const [changes, setChanges] = useState<boolean>(false);

  const pageChange = (event: GridPageChangeEvent) => {
    setState(createState(event.page.skip, event.page.take, props.data));
    props.pageSize(event.page.take, event.page.skip)
    
  }

 

  const itemChange = (event: GridItemChangeEvent) => {
    let field = event.field || "";
    event.dataItem[field] = event.value;
    let newData = data.map((item: any) => {
      if (item.name === event.dataItem.name) {
        item[field] = event.value;
      }
      return item;
    });
    setData(newData);
    setChanges(true);
  }

  const getTables = (type: string) => {
    if (type === 'appliedCandidates') {
      props.getAppliedCandidates()
    }
  }

  const rowClick = (e: any) => { 
   if(e.dataItem.candidateId){
     let inEdit = true
     let newEdit = false
     let newData = props.data.map((item: any) =>
       item.candidateId === e.dataItem.candidateId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
     setState(createState(state.skip, state.pageSize, newData))
   }
   if (e.dataItem.jobId) {
     let inEdit = true
     let newEdit = false
     let newData = props.data.map((item: any) =>
       item.jobId === e.dataItem.jobId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
     setState(createState(state.skip, state.pageSize, newData))  
   }
 }
  
  return (
      <div className="tableStyle">
          {props && props.type === 'activepositions' && <ActivePositions data={props.data} status={props.status}/>}
          {props && props.type === 'upcomingjoinee' && <UpcomingJoinee data={props.data} />}
          {props && props.type === 'positions' && <Positions data={props.data} draftKey={props.draftKey}/>}
          {props && props.type === 'resources' && <ContractResources pageChange={pageChange} state={state} data={data} total={props && props.data && props.data.length} itemChange={itemChange} />}
          {props && props.type === 'appliedCandidates' && <AppliedResourcesTable data={props.data} state={state} jobId={props.jobId}  getTables={() => getTables('appliedCandidates')} rowClick={rowClick}/>}
          {props && props.type === 'candidateTimeSheet' && <CandidateTimeSheet data={props.data} showHistory={props.showHistory}/>}
          {props && props.type === 'timeSheetHistory' && <TimeSheetHistory data={props.data}/>}
          {props && props.type === 'checkHistory' && <CheckHistoryTable data={props.data} onClose={props.onClose} sendReminder={props.sendReminder} timesheetHistory={props.timesheetHistory}/>}
    </div>
  )
}

export default Table